import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module image/imageresize/resizeimagecommand
 */
import { Command } from 'ckeditor5/src/core.js';
/**
 * The resize image command. Currently, it only supports the width attribute.
 */
var ResizeImageCommand = /*#__PURE__*/function (_Command) {
  _inherits(ResizeImageCommand, _Command);
  var _super = _createSuper(ResizeImageCommand);
  function ResizeImageCommand() {
    _classCallCheck(this, ResizeImageCommand);
    return _super.apply(this, arguments);
  }
  _createClass(ResizeImageCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var editor = this.editor;
      var imageUtils = editor.plugins.get('ImageUtils');
      var element = imageUtils.getClosestSelectedImageElement(editor.model.document.selection);
      this.isEnabled = !!element;
      if (!element || !element.hasAttribute('resizedWidth')) {
        this.value = null;
      } else {
        this.value = {
          width: element.getAttribute('resizedWidth'),
          height: null
        };
      }
    }
    /**
     * Executes the command.
     *
     * ```ts
     * // Sets the width to 50%:
     * editor.execute( 'resizeImage', { width: '50%' } );
     *
     * // Removes the width attribute:
     * editor.execute( 'resizeImage', { width: null } );
     * ```
     *
     * @param options
     * @param options.width The new width of the image.
     * @fires execute
     */
  }, {
    key: "execute",
    value: function execute(options) {
      var editor = this.editor;
      var model = editor.model;
      var imageUtils = editor.plugins.get('ImageUtils');
      var imageElement = imageUtils.getClosestSelectedImageElement(model.document.selection);
      this.value = {
        width: options.width,
        height: null
      };
      if (imageElement) {
        model.change(function (writer) {
          writer.setAttribute('resizedWidth', options.width, imageElement);
          writer.removeAttribute('resizedHeight', imageElement);
          imageUtils.setImageNaturalSizeAttributes(imageElement);
        });
      }
    }
  }]);
  return ResizeImageCommand;
}(Command);
export { ResizeImageCommand as default };